import { connect } from 'react-redux'
import View from './PageNotFound'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const PageNotFound = connect(mapStateToProps)(View)

export default PageNotFound
